import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { SubDepartment } from '../../models/subdepartment';
import { SubDepartmentService } from '../../services/subdepartment.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { DepartmentService } from '../../services/department.service';
import { Department } from '../../models/department';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service'; 
import { DivisionService } from '../../services/division.service';
import { Division } from '../../models/division';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';

@Component({
  selector: 'app-subdepartment',
  templateUrl: './subdepartment.component.html',
  styleUrls: ['./subdepartment.component.css']
})
export class SubDepartmentComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerSubDepartment: PageHeader;
  entity: SubDepartment = new SubDepartment();
  selectedSubDepartment: SubDepartment = new SubDepartment();
  editingEntity: SubDepartment = new SubDepartment();
  subdepartments: any;
  subdepartmentColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = ''; 
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  company: Array<Company> = [];
  selectedCompany: any;
  divisions: Array<Division> = [];
  selectedDivision: any;
  locations: Array<Location> = [];
  selectedLocation: any;
  departments: Array<Department> = [];
  selectedDepartment: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _subdepartmentService: SubDepartmentService, 
    private _divisionService: DivisionService,
    private _companyService: CompanyService,
    private _locationService: LocationService,
    private _departmentService: DepartmentService,
    private _employeeService: EmployeeService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerSubDepartment = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.subdepartments = [];
    this.getAllSubDepartment();
  }
  ngAfterViewInit(): void {
    this.subdepartmentColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "SubDepartmentName", title: 'Sub Department', filter: true, sortable: true , width: 150 },
      { field: "SubDepartmentPrefix", title: 'Code', filter: true, sortable: true, width: 100},
      { field: "EmployeeName", title: 'Head', filter: true, sortable: true , width: 150},
     // { field: "CompanyName", title: 'Company', filter: true, sortable: true },
      // { field: "DivisionName", title: 'Division', filter: true, sortable: true },
      // { field: "LocationName", title: 'Location', filter: true, sortable: true, width: 100 },
      { field: "DepartmentName", title: 'Department', filter: true, sortable: true, width: 150 }, 
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100}, 
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view } 
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._subdepartmentService.getAllSubDepartment('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<SubDepartment>) => {
      this.subdepartments = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllDivisions(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.divisions = data;
    })
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
      this.locations = data;
    })
  }
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      //0 FOR ALL RECORD FROM TABLE INCLUDING ACTIVE AND INACTIVE.
      this._subdepartmentService.getAllSubDepartment(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((subdepartments: Array<SubDepartment>) => {
        this.subdepartments = {
          data: subdepartments,
          total: subdepartments[0] ? subdepartments[0].TotalCount : 0
        }
      });
    }
  }
  getAllSubDepartment() {
    this._subdepartmentService.getAllSubDepartment('', Number(this.defaultPageSize), 1, 0, 0).subscribe((subdepartments: Array<SubDepartment>) => {
      this.subdepartments = {
        data: subdepartments,
        total: subdepartments[0] ? subdepartments[0].TotalCount : 0
      }
    })
  };
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._subdepartmentService.deleteSubDepartment(this.selectedSubDepartment.SubDepartment_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearSubDepartment();
            this.getAllSubDepartment();
          },
          )
        }
      }
    });
  }
  initPageHeader(): PageHeader {
    let headerSubDepartment = new PageHeader();
    headerSubDepartment.PageCaption = "Sub Department";
    headerSubDepartment.IconClass = "bi bi-shield-shaded";
    return headerSubDepartment;
  }
  deleteSubDepartment(event: any) {
    if (event.seletedRows[0]) {
      this.selectedSubDepartment.SubDepartment_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Sub Department",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  addSubDepartment(event: any) {
    this.listView = false;
    this.clearSubDepartment();
    this.getAllCompany('');
    this.getAllDivisions('');
    this.getAllLocations('');
    this.getAllDepartments('');
    this.getAllEmployees('');
    this.formCaption = "Add Sub Department";
  }
  editSubDepartment(event: any): void {
    if (event.seletedRows[0]) {
      this._subdepartmentService.viewSubDepartment(event.seletedRows[0]).subscribe((subdepartments: Array<SubDepartment>) => {
        let editEnity = subdepartments[0] ? subdepartments[0] : new SubDepartment();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, DivisionName: editEnity.DivisionName };
          this.selectedLocation = { Location_Id: editEnity.Location_Id, LocationName: editEnity.LocationName }; 
          this.selectedDepartment = { Department_Id: editEnity.Department_Id, DepartmentName: editEnity.DepartmentName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Sub Department"; 
          this.getAllEmployees('');
          this.getAllCompany('');
          this.getAllDivisions('');
          this.getAllLocations('');
          this.getAllDepartments('');
          this.entity.EntityMetaData = [
            { FieldName: 'SubDepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Sub Department Name is required' },
             { FieldName: 'SubDepartmentPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            //{ FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Sub Department Head is required' },       
          ];
        }
      });
    }
  }
  save(event: any): void {

    if(parseInt(this.entity.SubDepartmentPrefix)==0)
    {
      this.notification.showWarning('Zero not allowed');
      return
    }


    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._subdepartmentService.checkDuplication(this.entity.SubDepartment_Id,this.entity.SubDepartmentPrefix).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('SubDepartment Code already exists');
          this.saveDisabled = false;
        }
        // const re = /^(0*[1-9]+0*)+$/;
        // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
        // this.codeCheck = re.test(String(this.entity.SubDepartmentPrefix).toString());
        // this.codealCheck = real.test(String(this.entity.SubDepartmentPrefix).toString());
        // if (this.codealCheck == false&&this.codeCheck==false ) {
         
        //   this.notification.showWarning("Invalid code ");
        //   this.saveDisabled = false;
          
        // }
        else{
          if(this.entity.SubDepartmentPrefix != "" && this.entity.SubDepartmentPrefix.length > 10){
            this.notification.showWarning("Invalid Code!! ");
            this.saveDisabled = false;
          }
        
        else { 
          this._subdepartmentService.saveSubDepartment(this.entity).subscribe(() => {
            if (this.entity.SubDepartment_Id == '00000000-0000-0000-0000-000000000000') {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearSubDepartment();
            this.getAllSubDepartment();
          })
        }
      }
      }); 
    }
    else {
      this.saveDisabled = false;
    } 
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    } 
  }
  gotoBack(): void {
    this.listView = true;
    this.getAllSubDepartment();
  }
  refreshSubDepartments(event: any): void {
    this.subdepartments=[];
    this.getAllSubDepartment();
  }
  clearSubDepartment(): void {
    this.selectedLocation = {}; 
    this.selectedCompany = {}; 
    this.selectedDivision = {}; 
    this.selectedDepartment = {};
    this.selectedEmployee = {};
    this.entity = new SubDepartment();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.SubDepartment_Id=dataItem.SubDepartment_Id;
 this.details =[];
 this._subdepartmentService.viewSubDepartment(this.entity.SubDepartment_Id).subscribe((subdepartments: Array<SubDepartment>) => {
  this.opened = true;
  this.details = subdepartments[0];
  })}

}
